var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/*
* Copyright (c) 2022 LS ELECTRIC Co. Ltd. All Reserved.
*/
/*******************************************************************
 * @author Soongjin Park
 * @contact sjpark@detech.co.kr
 * @date 2022-09-20
 * @brief EHP 메뉴 관리 개발
 *
 ********************************************************************/
import React, { useEffect, useState } from "react";
import { useAsync } from "react-async";
import { useNavigate } from 'react-router-dom';
// recoil
import { useRecoilValue, useRecoilState, } from "recoil";
import { userInfoLoginState } from "../../../../recoil/userState";
import { loadingBoxState } from "../../../../recoil/menuState";
// utils
import clog from "../../../../utils/logUtils";
import * as CONST from "../../../../utils/Const";
import * as CUTIL from "../../../../utils/commUtils";
import * as HTTPUTIL from "../../../../utils/api/HttpUtil";
import MenuCombo from "../common/MenuCombo";
/**
 * @brief EHP 메뉴 관리 컴포넌트, 반응형 동작
 * @param -
 * @returns react components
 */
function AuthSetting(props) {
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const [isLoadingBox, setRecoilIsLoadingBox] = useRecoilState(loadingBoxState);
    //props
    const isMobile = props.isMobile;
    const adminType = props.adminType;
    const setParentAdminType = props.setAdminType;
    const selTree = props.selTree;
    const setParentSelTree = props.setSelTree;
    const workMode = props.workMode;
    const setParentWorkMode = props.setWorkMode;
    //화면 이동
    const navigate = useNavigate();
    //
    const [menuList, setMenuList] = useState([]);
    const defaultPageInfo = { "size": 10, "totalElements": 0, "totalPages": 0, "number": 0, "psize": 10 };
    const [pageInfo, setPageInfo] = useState(defaultPageInfo);
    function handleCurPage(page) {
        setPageInfo(Object.assign(Object.assign({}, pageInfo), { number: page }));
    }
    const [codeParam, setCodeParam] = useState("");
    let appPath = "";
    appPath = 'page=' + pageInfo.number + '&size=' + pageInfo.size;
    if (codeParam.length > 0) {
        appPath = appPath + "&menuCode=" + codeParam;
    }
    const [menuListReload, setMenuListReload] = useState(false);
    const [errorList, setErrorList] = useState([]);
    //{menuCode, menuName, errList : {}}
    //[{"field":"menuName","msg":"필수 항목입니다."}]
    const { data: retData, error, isLoading, reload, run, } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/api/v2/menus/admin?${appPath}`,
        appQuery: {},
        userToken: userInfo.loginInfo.token,
        watch: selTree + appPath + menuListReload
        //watch: selTree.company.companyId+selTree.reload
    });
    useEffect(() => {
        setRecoilIsLoadingBox(true);
        const ERR_URL = HTTPUTIL.resultCheck(isLoading, retData);
        if (ERR_URL.length > 0) {
            setRecoilIsLoadingBox(false);
            navigate(ERR_URL);
        }
        if (retData) {
            //clog("IN AUTH SETTING : RES : " + JSON.stringify(retData));
            setRecoilIsLoadingBox(false);
            if (retData.codeNum == CONST.API_200) {
                setMenuListReload(false); // list reload
                setIsEditable(false);
                setMenuList(retData.body);
                setPageInfo(Object.assign(Object.assign({}, retData.data.page), { psize: (isMobile) ? CONST.NUM_MLISTCNT : CONST.NUM_WLISTCNT })); //5, 10
            }
        }
    }, [selTree, retData]);
    const [isEditable, setIsEditable] = useState(false);
    // check..
    function onClickRoleSettingSRC(e, menuObj, strRole) {
        e.preventDefault();
        e.stopPropagation();
        const insRoleDtos = menuObj.roleDtos.filter((role) => (role.role === strRole));
        setMenuList(menuList.map((smenu) => (smenu.menuCode === menuObj.menuCode)
            ? Object.assign(Object.assign({}, smenu), { roleDtos: (insRoleDtos.length > 0) // role str toggle
                    ? menuObj.roleDtos.filter((role) => (role.role !== strRole)) // exist then role dto에 해당 권한 제외/삭제
                    : menuObj.roleDtos.concat({ "id": -1, "role": strRole }) // no exist then role dto에 해당 권한 추가
             }) : smenu));
        let tList = null;
        if (CUTIL.isnull(menuObj.parentCode)) { // 최상위 메뉴 처리 // 헤제일 경우만, 하위 모두 헤제
            //alert("최상위");
            if (insRoleDtos.length > 0) { // 하위 헤제
                setMenuList(menuList.map((cmenu) => (cmenu.parentCode === menuObj.menuCode)
                    ? Object.assign(Object.assign({}, cmenu), { roleDtos: cmenu.roleDtos.filter((role) => (role.role !== strRole)) }) : cmenu));
            }
        }
        else { // 하위 메뉴 처리 - 최상위에 권한 동시 추가
            alert("하위");
        }
    }
    function onClickRoleSetting(e, menuObj, strRole) {
        e.preventDefault();
        e.stopPropagation();
        const insRoleDtos = menuObj.roleDtos.filter((role) => (role.role === strRole));
        const sList = menuList.map((smenu) => (smenu.menuCode === menuObj.menuCode)
            ? Object.assign(Object.assign({}, smenu), { roleDtos: (insRoleDtos.length > 0) // role str toggle
                    ? menuObj.roleDtos.filter((role) => (role.role !== strRole)) // exist then role dto에 해당 권한 제외/삭제
                    : menuObj.roleDtos.concat({ "id": -1, "role": strRole }) // no exist then role dto에 해당 권한 추가
             }) : smenu);
        let tList = sList;
        if (CUTIL.isnull(menuObj.parentCode)) { // 최상위 메뉴 처리 // 헤제일 경우만, 하위 모두 헤제
            if (insRoleDtos.length > 0) { // 해당 권한이 있을때 -> 해제
                tList = sList.map((cmenu) => (cmenu.parentCode === menuObj.menuCode) // 하위 찾기
                    ? Object.assign(Object.assign({}, cmenu), { roleDtos: cmenu.roleDtos.filter((role) => (role.role !== strRole)) }) : cmenu);
            }
        }
        else { // 하위 메뉴 처리 - 최상위에 권한 동시 추가
            //alert("하위");
            if (insRoleDtos.length <= 0) { // 해당 권한이 없을때 -> 추가
                tList = sList.map((cmenu) => (cmenu.menuCode === menuObj.parentCode) // 상위 찾기
                    ? (cmenu.roleDtos.filter((role) => (role.role === strRole)).length > 0) // 상위에 해당 권한이 있으면...
                        ? cmenu
                        : Object.assign(Object.assign({}, cmenu), { roleDtos: cmenu.roleDtos.concat({ "id": -1, "role": strRole }) })
                    : cmenu);
            }
        }
        setMenuList(tList);
    }
    function onClickDoSaveRoleSetting(e) {
        return __awaiter(this, void 0, void 0, function* () {
            const errList = [];
            var doCnt = 0;
            var doneCnt = 0;
            var succCnt = 0;
            const failMenuList = [];
            var ret = confirm("변경 내용을 저장하시겠습니까?");
            if (!ret)
                return;
            setRecoilIsLoadingBox(true);
            menuList.map((menu) => __awaiter(this, void 0, void 0, function* () {
                doCnt++;
                let data = null;
                clog("EACH : " + JSON.stringify(menu));
                data = yield doSaveRoleSetting(menu);
                CUTIL.sleep(500);
                if (data) {
                    clog("EACH SAVE DONE : " + menu.menuCode + " : " + JSON.stringify(data));
                    doneCnt++;
                    if (data.codeNum == CONST.API_200) {
                        succCnt++;
                    }
                    else { // api if
                        // need error handle
                        //setErrorList(data.body.errorList);
                        //errList.push({menuCode : menu.menuCode, roleField : data.body.errorList[0].field, errList : data.body.errorList});
                        failMenuList.push(menu);
                    }
                    if (doneCnt === menuList.length) {
                        if (doCnt === succCnt) {
                            setMenuListReload(true); // reload
                            //setErrorList(errList);
                            alert("저장되었습니다.");
                        }
                        else {
                            //alert("저장 중 오류가 발생했습니다. 오류내역을 확인하세요.");
                            //clog("FAILS 2 : " + doCnt + " : " + succCnt + " : " + doneCnt);
                            doSaveFailedRoleSetting(failMenuList);
                        }
                        doneCnt = 0;
                        setRecoilIsLoadingBox(false);
                    }
                }
            }));
        });
    }
    function doSaveFailedRoleSetting(failList) {
        return __awaiter(this, void 0, void 0, function* () {
            const errList = [];
            var doCnt = 0;
            var doneCnt = 0;
            var succCnt = 0;
            //const failMenuList = [];
            setRecoilIsLoadingBox(true);
            failList.map((menu) => __awaiter(this, void 0, void 0, function* () {
                doCnt++;
                let data = null;
                clog("EACH : " + JSON.stringify(menu));
                data = yield doSaveRoleSetting(menu);
                CUTIL.sleep(500);
                if (data) {
                    clog("EACH SAVE DONE : " + menu.menuCode + " : " + JSON.stringify(data));
                    doneCnt++;
                    if (data.codeNum == CONST.API_200) {
                        succCnt++;
                    }
                    else { // api if
                        // need error handle
                        //setErrorList(data.body.errorList);
                        errList.push({ menuCode: menu.menuCode, roleField: data.body.errorList[0].field, errList: data.body.errorList });
                    }
                    if (doneCnt === failList.length) {
                        setMenuListReload(true); // reload
                        setErrorList(errList);
                        if (doCnt === succCnt) {
                            alert("저장되었습니다.");
                        }
                        else {
                            alert("저장 중 오류가 발생했습니다. 오류내역을 확인하세요.");
                        }
                        doneCnt = 0;
                        setRecoilIsLoadingBox(false);
                    }
                }
            }));
        });
    }
    function doSaveRoleSetting(menu) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                "httpMethod": "PUT",
                "appPath": `/api/v2/menus/role`,
                appQuery: {
                    "menuCode": menu.menuCode,
                    "roles": menu.roleDtos.map((role) => role.role)
                },
                userToken: userInfo.loginInfo.token,
            });
            return data;
        });
    }
    function onClickDoInitMenu(e) {
        return __awaiter(this, void 0, void 0, function* () {
            var isOk = confirm("메뉴별 권한을 초기 설정값으로 복원하시겠습니까?");
            if (!isOk)
                return;
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                "httpMethod": "PUT",
                "appPath": `/api/v2/menus/init`,
                appQuery: {},
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum === CONST.API_200) {
                    setMenuListReload(true); // list reload
                    clog("IN onClickDoInitMenu : " + JSON.stringify(data.body));
                }
            }
        });
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "area__right_content workplace__info workplace__main info__input newtype" },
            React.createElement("div", { className: "page-top" },
                React.createElement("h2", null, "\uBA54\uB274\uBCC4 \uAD8C\uD55C \uC124\uC815")),
            React.createElement("div", { className: "tbl__top mb-16" },
                React.createElement("div", { className: "left" },
                    React.createElement(MenuCombo, { selTree: props.selTree, setCodeParam: setCodeParam, setCurPage: handleCurPage })),
                React.createElement("div", { className: "right" },
                    React.createElement("button", { type: "button", className: "bg-gray mr-8", onClick: (e) => onClickDoInitMenu(e) },
                        React.createElement("span", null, "\uCD08\uAE30\uD654")),
                    (!isEditable) &&
                        React.createElement("button", { type: "button", className: "bg-gray", onClick: (e) => setIsEditable(true) },
                            React.createElement("span", null, "\uC218\uC815")),
                    (isEditable) && React.createElement("button", { type: "button", className: "bg-blue", onClick: (e) => onClickDoSaveRoleSetting(e) },
                        React.createElement("span", null, "\uC800\uC7A5")))),
            React.createElement("div", { className: "tbl-list menuset-list" },
                React.createElement("table", { summary: "\uBA54\uB274,\uC0C1\uC138\uBA54\uB274,\uC124\uBA85,Admin,Engineer,User,None \uD56D\uBAA9\uC73C\uB85C \uAD6C\uC131\uB41C \uBA54\uB274\uBCC4 \uAD8C\uD55C \uC124\uC815 \uB9AC\uC2A4\uD2B8 \uC785\uB2C8\uB2E4." },
                    React.createElement("caption", null, "\uBA54\uB274\uBCC4 \uAD8C\uD55C \uC124\uC815 \uB9AC\uC2A4\uD2B8"),
                    React.createElement("colgroup", null,
                        React.createElement("col", { style: { "width": "" } })),
                    React.createElement("thead", null,
                        React.createElement("tr", null,
                            React.createElement("th", { scope: "col", className: "txt-left" }, "\uBA54\uB274"),
                            React.createElement("th", { scope: "col", className: "txt-left" }, "\uC0C1\uC138\uBA54\uB274"),
                            React.createElement("th", { scope: "col", className: "txt-left d-lm-none" }, "\uC124\uBA85"),
                            React.createElement("th", { scope: "col" }, "Admin"),
                            React.createElement("th", { scope: "col" }, "Engineer"),
                            React.createElement("th", { scope: "col" }, "User"),
                            React.createElement("th", { scope: "col" }, "None"))),
                    React.createElement("tbody", null, menuList.map((smenu, idx) => (React.createElement("tr", { key: `menu_${idx.toString()}` },
                        React.createElement("td", { className: "txt-left" },
                            React.createElement("p", { className: "ellipsis" }, smenu.depthName1)),
                        React.createElement("td", { className: "txt-left" },
                            React.createElement("p", { className: "ellipsis" }, smenu.depthName2)),
                        React.createElement("td", { className: "txt-left d-lm-none" },
                            smenu.description,
                            "/",
                            smenu.menuCode),
                        React.createElement("td", { className: "w60", onClick: (e) => (isEditable) && onClickRoleSetting(e, smenu, CONST.USERROLE_ADMIN) },
                            React.createElement("input", { type: "checkbox", id: "a_11", className: (errorList.filter((err) => (err.menuCode === smenu.menuCode) && (err.roleField === CONST.USERROLE_ADMIN)).length > 0) ? "error" : "", checked: (smenu.roleDtos.filter((role) => role.role === CONST.USERROLE_ADMIN).length > 0) ? true : false, disabled: (!isEditable) ? true : false }),
                            React.createElement("label", { htmlFor: "a_11" },
                                React.createElement("span", { className: "hide" }, "\uC120\uD0DD"))),
                        React.createElement("td", { className: "w60", onClick: (e) => (isEditable) && onClickRoleSetting(e, smenu, CONST.USERROLE_ENGINEER) },
                            React.createElement("input", { type: "checkbox", id: "e_12", className: (errorList.filter((err) => (err.menuCode === smenu.menuCode) && (err.roleField === CONST.USERROLE_ENGINEER)).length > 0) ? "error" : "", checked: (smenu.roleDtos.filter((role) => role.role === CONST.USERROLE_ENGINEER).length > 0) ? true : false, disabled: (!isEditable) ? true : false }),
                            React.createElement("label", { htmlFor: "e_12" },
                                React.createElement("span", { className: "hide" }, "\uC120\uD0DD"))),
                        React.createElement("td", { className: "w60", onClick: (e) => (isEditable) && onClickRoleSetting(e, smenu, CONST.USERROLE_USER) },
                            React.createElement("input", { type: "checkbox", id: "u_13", className: (errorList.filter((err) => (err.menuCode === smenu.menuCode) && (err.roleField === CONST.USERROLE_USER)).length > 0) ? "error" : "", checked: (smenu.roleDtos.filter((role) => role.role === CONST.USERROLE_USER).length > 0) ? true : false, disabled: (!isEditable) ? true : false }),
                            React.createElement("label", { htmlFor: "u_13" },
                                React.createElement("span", { className: "hide" }, "\uC120\uD0DD"))),
                        React.createElement("td", { className: "w60", onClick: (e) => (isEditable) && onClickRoleSetting(e, smenu, CONST.USERROLE_NONE) },
                            React.createElement("input", { type: "checkbox", id: "n_14", className: (errorList.filter((err) => (err.menuCode === smenu.menuCode) && (err.roleField === CONST.USERROLE_NONE)).length > 0) ? "error" : "", checked: (smenu.roleDtos.filter((role) => role.role === CONST.USERROLE_NONE).length > 0) ? true : false, disabled: (!isEditable) ? true : false }),
                            React.createElement("label", { htmlFor: "n_14" },
                                React.createElement("span", { className: "hide" }, "\uC120\uD0DD"))))))))))));
}
;
export default AuthSetting;
